/* ALO-style price + reviews row on the PDP.
   Wraps the price block (.product__price) and the Judge.me preview badge wrapper
   (.product__app-block holding .jdgm-preview-badge) into one flex row (#pd-price-row)
   with a thin "|" separator, so they sit on a single line instead of stacked.

   The price keeps its theme id, so the theme still updates it in place on variant
   change; we re-assert the row on every re-render (and when Judge.me injects the
   badge async) via a MutationObserver anchored on the stable .shopify-section.
   ASCII-only. */
(function () {
  var host = null, mo = null;

  function build() {
    var price = document.querySelector('.product__price');
    if (!price) { return; }

    var badge = document.querySelector('.jdgm-preview-badge');
    var badgeWrap = badge ? (badge.closest('.product__app-block') || badge.parentNode) : null;

    var row = document.getElementById('pd-price-row');
    if (!row) {
      row = document.createElement('div');
      row.id = 'pd-price-row';
      row.className = 'pd-price-row';
      price.parentNode.insertBefore(row, price);
    }
    // price first (theme updates it in place by id, so this stays correct on variant change)
    if (price.parentNode !== row) { row.insertBefore(price, row.firstChild); }

    if (badgeWrap) {
      var sep = row.querySelector('.pd-price-sep');
      if (!sep) {
        sep = document.createElement('span');
        sep.className = 'pd-price-sep';
        sep.setAttribute('aria-hidden', 'true');
        row.appendChild(sep);
      }
      if (badgeWrap.parentNode !== row) { row.appendChild(badgeWrap); }
    }
  }

  // Disconnect while mutating so our own DOM changes don't retrigger the observer.
  function run() {
    if (mo) { mo.disconnect(); }
    build();
    if (mo && host) { mo.observe(host, { childList: true, subtree: true }); }
  }

  function init() {
    var price = document.querySelector('.product__price');
    host = (price && price.closest('.shopify-section'))
      || document.querySelector('.shopify-section')
      || document.body;
    mo = new MutationObserver(run);
    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
